"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _times = _interopRequireDefault(require("lodash/times"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var PulseLoader = function PulseLoader(_ref) {
  var className = _ref.className,
      size = _ref.size,
      borderWidth = _ref.borderWidth,
      additionalMarkup = _ref.additionalMarkup;
  var classes = (0, _classnames.default)('PulseLoader', className);
  var borderWidthx4 = borderWidth * 4;
  var numInnerRings = size / borderWidthx4 - 1;
  return _react.default.createElement("div", {
    className: classes
  }, _react.default.createElement("div", {
    className: "PulseLoader-pulse",
    style: {
      width: size,
      height: size
    }
  }, _react.default.createElement("div", {
    className: "PulseLoader-pulse-outer"
  }, _react.default.createElement("div", {
    className: "PulseLoader-pulse-ring",
    style: {
      borderWidth: borderWidth
    }
  })), (0, _times.default)(numInnerRings, function (i) {
    var newSize = size - borderWidthx4 * (i + 1);
    return _react.default.createElement("div", {
      key: i,
      className: "PulseLoader-pulse-inner",
      style: {
        width: newSize,
        height: newSize
      }
    }, _react.default.createElement("div", {
      className: "PulseLoader-pulse-ring",
      style: {
        borderWidth: borderWidth
      }
    }));
  })), additionalMarkup);
};

PulseLoader.defaultProps = {
  size: 120,
  borderWidth: 7
};
var _default = PulseLoader;
exports.default = _default;